module.exports = __webpack_public_path__ + "static/HUIPUT_slogan_EN-05-1c1dc47ca653e8d0c607e9b48b946ed4.svg";